<div *ngIf="!db.hide_cat_categories"  class="mobile_category_list">
  <app-category-list  (filter)="get_cat_products($event)"></app-category-list>
</div>

<h6 *ngIf="db.ismobile && db.hide_cat_categories" class="bold_name m-0 head_price">Search Results</h6>

<div class="mainwidth" id="content">
  <div class="list-container">
    <div class="side-one">
      <!-- <app-category-bar (filter)="get_cat_products('')"></app-category-bar> -->
      <app-categories (filter)="get_cat_products('')"></app-categories>
    </div>
    <div class="side-two" (scroll)="!this.db.no_inventory_products ? loadData($event) : null" [ngClass]="(db.id_sub_category) ?'sub_side_three':'side-two'">
      <div *ngIf="db.skeleton">
        <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </div>
 
      <div *ngIf="db.view == 'grid'"  class="container normal__grids p0">
       <!-- (click)="add_cart(item,db.plusCount(item.count))" -->
        <div (click)="added_product_list(item,index)" [ngClass]="{'bdrr':((index + 1 ) % 4)}"  class="mouse grid__item" *ngFor="let item of db.cat_products; let index = index;">
          <div class="image">
            <!-- <app-cached-image [src]="item.image" [spinner]="true"></app-cached-image> -->
            <img  src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
            <span class="m-0" class="discount" *ngIf="item.discount_percentage">{{item.discount_percentage}}%</span>
          </div>
          <div class="description-container">
            <div class="description">
              <div class="div_">
                <h3 class="bold_name-14 m-0 webkit-text" [style.--line]="2" >{{item.item | titlecase}}</h3>
                <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
                <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 mouse m-0"><span>{{item.variants.length}}</span> Variants</h5>
              </div>
              <ion-button [class.active]="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" class="add_btn" fill="clear">{{(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)  ? 'Added' : 'Add'}} 
                <ion-icon *ngIf="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" name="checkmark-circle-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="db.view == 'grid_img' " class="container normal__grids p0">
        <!-- (click)="add_cart(item,db.plusCount(item.count))" -->
        <div (click)="added_product_list(item,index)" [ngClass]="{'bdrr':((index + 1 ) % 4)}"  class="mouse grid__item" *ngFor="let item of db.cat_products; let index = index;">
          <div class="description-container">
            <div class="description">
              <div class="div_">
                <h3 class="m-0 bold_name-14 webkit-text" [style.--line]="2" >{{item.item | titlecase}}</h3>
                <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
                <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 m-0 mouse"><span>{{item.variants.length}}</span> Variants</h5>
              </div>
              <ion-button [class.active]="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" class="add_btn" fill="clear">{{(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)  ? 'Added' : 'Add'}} 
                <ion-icon *ngIf="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" name="checkmark-circle-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="db.view == 'list'" class="p0">
        <ion-row>
          <ion-col  [size]="db.column_value" *ngFor="let item of db.cat_products; let index = index;" [id]="index+'s'" [class.active_dropdown]="index == active_dropdwon" class="list_container p0">
            <!-- (click)="add_cart(item,db.plusCount(item.count))" -->
            <ion-item (click)="added_product_list(item,index)" button  lines="none">
              <ion-thumbnail slot="start">
                <img src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
              </ion-thumbnail>
              <ion-label>
                  <h3 class="bold_name-14" >{{item.item | titlecase}}</h3>
                  <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
                  <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 mouse"><span>{{item.variants.length}}</span> Variants</h5>
                  <!-- <div *ngIf="item.attribute_html" class="prices"> -->
                    <!-- <p class="m-0 price cat-price" [innerHtml]="item.attribute_html" ></p> -->
                  <!-- <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="sans-font"></span>{{item.old_price |currency:db.currency}}</p> -->
                  <!-- <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="sans-font"></span>{{item.price |currency:db.currency}}</p> -->
                  <!-- <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p> -->
                  <!-- </div> -->
              </ion-label>

              <ion-button [class.active]="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" class="add_btn" fill="clear">{{(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)  ? 'Added' : 'Add'}} 
                <ion-icon *ngIf="(item['Added_to_inventory'] && item['Added_to_inventory'] == 1)" name="checkmark-circle-outline"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-col>
        </ion-row>
        <!-- <ion-infinite-scroll *ngIf="!db.no_inventory_products" threshold="800px" (ionInfinite)="loadData($event)">
          <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText=""></ion-infinite-scroll-content>
        </ion-infinite-scroll> -->
      </div>

     <app-no-record-found *ngIf="!db.skeleton && db.cat_products.length == 0" [column]="true" [height]="db.ismobile ? 'calc(100vh - 280px)' : 'calc(100vh - 112px)'" heading="No Products for selected Category" [image]="'assets/no-product-POS.svg'"></app-no-record-found>

    </div>
    <div class="side-three" [ngClass]="(db.id_sub_category) ?'sub_side_three':'side-two'">
      <!-- <app-your-cart [load]="true"></app-your-cart> -->
      <app-inventory-checkout (submit)="submit.emit()"></app-inventory-checkout>
    </div>
  </div>
</div>
